import React from 'react'

import { Box, Button, Grid } from '@mui/material'
import { toast } from 'react-toastify'

import { CardTitle, ConfirmDialog } from 'components/common'
import { useDeleteActivityMutation } from 'generated/graphql'
import { Restricted } from 'providers/PermissionProvider'

import { CreateUpdateActivity } from './CreateUpdateActivity'
import HistoryList from './HistoryList'

interface IProps {
  bookingId: string | null
}

const History = (props: IProps) => {
  const { bookingId } = props

  const [selectedActivityId, setSelectedActivityId] = React.useState<number | null>(null)
  const [openActivityDialog, setOpenActivityDialog] = React.useState(false)
  const [activityIdToDelete, setActivityIdToDelete] = React.useState<string | null>(null)
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false)

  // mutations
  const [deleteActivity] = useDeleteActivityMutation({
    onCompleted: () => toast.success('Activity was deleted with success.'),
  })

  // handlers
  const handleLogActivity = () => {
    setSelectedActivityId(null)
    setOpenActivityDialog(true)
  }

  const handleActivityClick = (id) => {
    setSelectedActivityId(Number(id))
    setOpenActivityDialog(true)
  }

  const handleDeleteClick = (id) => {
    setActivityIdToDelete(id)
    setOpenDeleteConfirmation(true)
  }

  const handleConfirmDelete = () => {
    if (activityIdToDelete === null) {
      return
    }

    deleteActivity({
      variables: { id: Number(activityIdToDelete) },
      update(cache) {
        cache.modify({
          fields: {
            activities(existingActivities = {}, { readField }) {
              const edges = existingActivities.edges.filter(
                (activityEdge) => activityIdToDelete !== readField('id', activityEdge.node),
              )

              return { ...existingActivities, edges }
            },
          },
        })
      },
    })
  }

  const handleCancelDelete = () => {
    setActivityIdToDelete(null)
  }

  const handleCloseActivityDialog = () => {
    setOpenActivityDialog(false)
  }

  return (
    <>
      <Box paddingX={2} paddingTop={2}>
        <Grid container justifyContent='space-between'>
          <Grid item>
            <CardTitle>History</CardTitle>
          </Grid>
          {bookingId && (
            <Restricted to='CreateActivity'>
              <Grid item>
                <Button variant='outlined' onClick={handleLogActivity}>
                  Log Activity
                </Button>
              </Grid>
            </Restricted>
          )}
        </Grid>
      </Box>

      <HistoryList
        bookingId={bookingId}
        onActivityClick={handleActivityClick}
        onDeleteClick={handleDeleteClick}
      />

      {openActivityDialog && (
        <CreateUpdateActivity
          id={selectedActivityId}
          bookingId={bookingId}
          openDialog={openActivityDialog}
          onCloseDialog={handleCloseActivityDialog}
        />
      )}

      <ConfirmDialog
        open={openDeleteConfirmation}
        setOpen={setOpenDeleteConfirmation}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        title='Confirmation'
        message='Are you sure you want to delete this note?'
        option1='No'
        option2='Yes'
      />
    </>
  )
}

export default History
